import { render, staticRenderFns } from "./BUS_info.vue?vue&type=template&id=5feb5b14&"
import script from "./BUS_info.vue?vue&type=script&lang=js&"
export * from "./BUS_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports